export enum CodeType {
  Unknown = 0,
  QR = 1,
  EAN13 = 2,
  CODE128 = 3,
}
